import { decouperInvariants } from '@/lib/invariants';
import type { Invariant } from '@rosetta/shared';
import { MarqueInvariant } from './marque-invariant';

interface TexteInvariantsProps {
  texte: string;
  /** The invariants to mark where they are written as they are; none, and the text is plain. */
  invariants?: readonly Invariant[] | null | undefined;
}

/** A text as it is, with its invariants marked. The characters are the ones of the text. */
export function TexteInvariants({ texte, invariants }: TexteInvariantsProps) {
  if (invariants == null || invariants.length === 0) return texte;

  // The position in the text is the key: the pieces are never reordered.
  let position = 0;
  return decouperInvariants(texte, invariants).map((segment) => {
    const cle = position;
    position += segment.texte.length;
    return segment.type === 'texte' ? (
      <span key={cle}>{segment.texte}</span>
    ) : (
      <MarqueInvariant key={cle} verrou={segment.verrou}>
        {segment.texte}
      </MarqueInvariant>
    );
  });
}
